export default (
  <>
    <path
      d="M9.96352 9.3568C10.1973 9.27562 10.4471 9.23199 10.7074 9.23199C11.8412 9.23199 12.7879 10.0682 13.005 11.18L14.6126 10.8392C14.2437 8.95087 12.6355 7.52893 10.7074 7.52893C10.265 7.52893 9.84043 7.60357 9.44336 7.74148L9.96352 9.3568Z"
      fill="currentColor"
    />
    <path
      d="M8.06593 14.7645L9.15339 13.4885C8.66791 13.0421 8.36181 12.3909 8.36181 11.6653C8.36181 10.9401 8.66761 10.2892 9.15249 9.84322L8.06503 8.56713C7.24057 9.32509 6.7207 10.4323 6.7207 11.6653C6.7207 12.899 7.24117 14.0065 8.06593 14.7645Z"
      fill="currentColor"
    />
    <path
      d="M13.0057 12.1542C12.7882 13.2648 11.8423 14.0998 10.7087 14.0998C10.4481 14.0998 10.1977 14.0561 9.96428 13.9745L9.44336 15.5901C9.84058 15.7282 10.266 15.8023 10.7087 15.8023C12.6351 15.8023 14.243 14.3834 14.6133 12.496L13.0057 12.1542Z"
      fill="currentColor"
    />
    <path
      d="M19.2332 13.039C19.2326 13.0398 19.2323 13.0401 19.232 13.0409L19.1861 13.0085C19.0544 13.2306 18.8494 13.4101 18.59 13.5265C18.0965 13.7493 17.6394 13.6921 17.3113 13.3932L17.2811 13.4406L16.7202 14.3092C16.8592 14.4093 17.0085 14.4945 17.1653 14.5623C17.7837 14.8287 18.4164 14.8163 19.0397 14.535C19.4904 14.3326 19.8442 14.0231 20.0862 13.631L19.2332 13.039ZM17.4854 10.8944C16.9651 11.1267 16.6962 11.6338 16.7516 12.2287L18.9579 11.2428C18.5789 10.7797 18.0848 10.6265 17.4854 10.8944ZM16.0207 13.5425C15.9678 13.454 15.8962 13.3121 15.8531 13.208C15.5987 12.5945 15.5864 11.9596 15.8014 11.3502C16.0376 10.6815 16.4895 10.1699 17.0726 9.90938C17.8065 9.58152 18.6177 9.6465 19.3209 10.0792C19.7672 10.3451 20.0838 10.7557 20.3243 11.3363C20.3551 11.4106 20.3817 11.4904 20.4081 11.5577L16.0207 13.5425Z"
      fill="currentColor"
    />
    <path
      d="M21.9391 8.62954V13.463L22.663 13.7674L22.2516 14.7634L21.4527 14.4187C21.2731 14.3379 21.1512 14.2145 21.0586 14.0751C20.9707 13.9332 20.9043 13.7384 20.9043 13.4763V8.62954H21.9391Z"
      fill="currentColor"
    />
    <path
      d="M23.8169 12.2313C23.8172 11.8199 23.9925 11.4508 24.2693 11.1999L23.5265 10.3405C23.0229 10.8028 22.706 11.4777 22.7051 12.2302C22.7042 12.9835 23.0208 13.6592 23.5246 14.1226L24.266 13.262C23.9907 13.0105 23.8166 12.6419 23.8169 12.2313Z"
      fill="currentColor"
    />
    <path
      d="M25.1344 13.6028C24.9881 13.6025 24.8477 13.5773 24.7161 13.5317L24.3613 14.6269C24.6038 14.7114 24.8638 14.7572 25.1335 14.7575C26.3093 14.7586 27.2915 13.8925 27.5191 12.7411L26.4286 12.5103C26.3049 13.1342 25.7722 13.6034 25.1344 13.6028Z"
      fill="currentColor"
    />
    <path
      d="M25.1367 9.7069C24.8669 9.70659 24.6078 9.75209 24.3652 9.83577L24.7171 10.9316C24.8488 10.8865 24.9896 10.8613 25.1358 10.8613C25.775 10.8621 26.3078 11.3339 26.4285 11.9597L27.519 11.7299C27.295 10.577 26.3139 9.70768 25.1367 9.7069Z"
      fill="currentColor"
    />
  </>
);
